webpackJsonp([114934724963867],{

/***/ 313:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/portfolio-item/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---portfolio-item-8da1c147369d77f3036f.js